import { Button, Card, Result, Space } from 'antd';
import axios from 'axios';
import { useState } from 'react';

import useStore from '../../store/useStore';

const RequestSuccess = () => {
  const setUser = useStore((state) => state.setUser);
  const [loading, setLoading] = useState(false);

  const reloadToken = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post('/api/v1/me/reloadToken');
      if (data.statusCode === 200) {
        setUser({
          token: data?.result?.token ?? null,
          email: data?.result?.email ?? null,
          merchantCodeList: data?.result?.merchantCodeList ?? [],
          menu: data?.result?.menu ?? null,
          menuItems: data?.result?.menuItems ?? null,
          merchantCode: data?.result?.merchantCode ?? null,
          merchantName: data?.result?.merchantName ?? null,
          merchantLogo: data?.result?.merchantLogo ?? null,
          meta: data?.result?.meta ?? [],
          isB2B: data?.result?.isB2B ?? false,
          serviceType: data?.result?.serviceType ?? [],
        });
      }
    } catch (e) {
      console.error('Reload Token: ', e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Space direction="vertical" size={16} style={{ width: '100%', padding: 16 }}>
      <Card size="middle">
        <Result
          status="success"
          title="Таны хүсэлтийг хүлээж авлаа"
          subTitle="Борлуулалтын ажилтан тантай холбогдоно. Хүсэлтийн явцыг доорх товчоор шалгана уу."
          extra={
            <Button type="primary" onClick={reloadToken} loading={loading}>
              Хүсэлт шалгах
            </Button>
          }
        />
      </Card>
    </Space>
  );
};

export default RequestSuccess;
